import React, { createContext,useState } from 'react'
export const orderContext = createContext();
export const OrderProvider = (props)=> {
    const [orders,addOrders] = useState([]);
    return (
        <orderContext.Provider value={[orders,addOrders]}>
            {props.children}
        </orderContext.Provider>
    )
}
